import { ValueOf } from '@/types/util';

export const EGiftStatus = {
  NOT_STARTED: '販売予定',
  ON_SALE: '販売中',
  ENDED: '販売終了',
} as const;

export type GiftStatusKey = keyof typeof EGiftStatus;
export type GiftStatusValue = ValueOf<typeof EGiftStatus>;

export const giftStatusKeys = Object.keys(EGiftStatus) as GiftStatusKey[];

/** v-select用items */
export const giftStatusItems = giftStatusKeys
  .map((key) => ({
    title: EGiftStatus[key],
    value: key,
  }));
